//------------ REACT IMPORT --------------//
import React from "react";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Card, Image } from "react-bootstrap";
import { BloodPressure, BloodSugar, HealthPerson, HeartRate, OxygenSaturation, Temperature1 } from "../../../../assets/images";
import PaginationComponent from "../../CommanComponents/Pagination";

const Health = () => {
    return (
        <>
            <div className="health_tab_screen">
                <Card>
                    <Card.Body>
                        <div className="card_details">
                            <div className="left_area">
                                <div className="inner_left_area">
                                    <ul>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={HeartRate} alt="..." />
                                                    </div>
                                                    <h6>Heart Rate</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodPressure} alt="..." />
                                                    </div>
                                                    <h6>Blood Pressure</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={Temperature1} alt="..." />
                                                    </div>
                                                    <h6>Temprature</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={OxygenSaturation} alt="..." />
                                                    </div>
                                                    <h6>Oxygen Saturation</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodSugar} alt="..." />
                                                    </div>
                                                    <h6>Blood Sugar</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                                <div className="inner_right_area">
                                    <ul>
                                        <li>
                                            <div className="details_list">
                                                <p>89 bpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>102 / 72 mmhg</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>80 Celsius </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>97 %spo2 60 PRbpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>140 mg / dl</p>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="right_area">
                                <div className="person_details">
                                    <div className="img_person">
                                        <Image src={HealthPerson} alt="..." />
                                    </div>
                                    <h5>Jospeh Jones</h5>
                                    <p>12 June, 2023  10:00AM</p>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className="card_details">
                            <div className="left_area">
                                <div className="inner_left_area">
                                    <ul>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={HeartRate} alt="..." />
                                                    </div>
                                                    <h6>Heart Rate</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodPressure} alt="..." />
                                                    </div>
                                                    <h6>Blood Pressure</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={Temperature1} alt="..." />
                                                    </div>
                                                    <h6>Temprature</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={OxygenSaturation} alt="..." />
                                                    </div>
                                                    <h6>Oxygen Saturation</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodSugar} alt="..." />
                                                    </div>
                                                    <h6>Blood Sugar</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                                <div className="inner_right_area">
                                    <ul>
                                        <li>
                                            <div className="details_list">
                                                <p>89 bpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>102 / 72 mmhg</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>80 Celsius </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>97 %spo2 60 PRbpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>140 mg / dl</p>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="right_area">
                                <div className="person_details">
                                    <div className="img_person">
                                        <Image src={HealthPerson} alt="..." />
                                    </div>
                                    <h5>Jospeh Jones</h5>
                                    <p>12 June, 2023  10:00AM</p>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className="card_details">
                            <div className="left_area">
                                <div className="inner_left_area">
                                    <ul>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={HeartRate} alt="..." />
                                                    </div>
                                                    <h6>Heart Rate</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodPressure} alt="..." />
                                                    </div>
                                                    <h6>Blood Pressure</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={Temperature1} alt="..." />
                                                    </div>
                                                    <h6>Temprature</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={OxygenSaturation} alt="..." />
                                                    </div>
                                                    <h6>Oxygen Saturation</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodSugar} alt="..." />
                                                    </div>
                                                    <h6>Blood Sugar</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                                <div className="inner_right_area">
                                    <ul>
                                        <li>
                                            <div className="details_list">
                                                <p>89 bpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>102 / 72 mmhg</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>80 Celsius </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>97 %spo2 60 PRbpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>140 mg / dl</p>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="right_area">
                                <div className="person_details">
                                    <div className="img_person">
                                        <Image src={HealthPerson} alt="..." />
                                    </div>
                                    <h5>Jospeh Jones</h5>
                                    <p>12 June, 2023  10:00AM</p>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className="card_details">
                            <div className="left_area">
                                <div className="inner_left_area">
                                    <ul>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={HeartRate} alt="..." />
                                                    </div>
                                                    <h6>Heart Rate</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodPressure} alt="..." />
                                                    </div>
                                                    <h6>Blood Pressure</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={Temperature1} alt="..." />
                                                    </div>
                                                    <h6>Temprature</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={OxygenSaturation} alt="..." />
                                                    </div>
                                                    <h6>Oxygen Saturation</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="person_health_details">
                                                <div className="details">
                                                    <div className="img_heart">
                                                        <Image src={BloodSugar} alt="..." />
                                                    </div>
                                                    <h6>Blood Sugar</h6>
                                                </div>
                                                <span>:</span>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                                <div className="inner_right_area">
                                    <ul>
                                        <li>
                                            <div className="details_list">
                                                <p>89 bpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>102 / 72 mmhg</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>80 Celsius </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>97 %spo2 60 PRbpm</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="details_list">
                                                <p>140 mg / dl</p>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="right_area">
                                <div className="person_details">
                                    <div className="img_person">
                                        <Image src={HealthPerson} alt="..." />
                                    </div>
                                    <h5>Jospeh Jones</h5>
                                    <p>12 June, 2023  10:00AM</p>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
            <PaginationComponent />
        </>
    )
}

export default Health;